import { useMovementV2PageData } from 'src/app/pages/movementV2/pageContext';

type Result = ModelHookResult<{
	description: string | null;
	objective: string;
	hasMovementPhoto: boolean;
	petitionCount: number;
	petitionCountLocalized: string;
	supporterCount: number;
	supporterCountLocalized: string;
}>;

export function usePageHeading(): Result {
	const {
		data: {
			movement: {
				description,
				objective,
				photo,
				petitionCount,
				petitionCountLocalized,
				uniqueSignatureCount: supporterCount,
				uniqueSignatureCountLocalized: supporterCountLocalized,
			},
		},
	} = useMovementV2PageData();

	const hasMovementPhoto = !!photo?.petitionMedium.url;

	return {
		data: {
			description,
			objective,
			hasMovementPhoto,
			petitionCount,
			petitionCountLocalized,
			supporterCount,
			supporterCountLocalized,
		},
	};
}
